<template>
    <div class="row container-fluid mt-4 g-3 p-0 align-items-center input">
        <div class="p-0 d-flex align-items-center" :class="{ 'col-6': !labelTop, 'col-12 mb8': labelTop }">
            <label :for="id" :class="{ 'primary-grey': !labelTop, 'fsp14 lh20': labelTop }">{{this.label}}</label>
            <Popper v-if="this.hint" :hover="true" :id="id + '_hint'">
                <Icon name="info" size="c16" class="ml4" />
                <template #content>
                    <span>{{ this.hint }}</span>
                </template>
            </Popper>
        </div>
        <div class="p-0 input-wrapper d-flex align-items-center gap-2" :class="{ 'col-6': !labelTop, 'col-12': labelTop, 'm-0': labelTop }">
            <InputDateSimple
                class="flex-grow-1"
                :id="id"
                :dataValue='this.dataValue'
                :expFormat="this.expFormat"
                :disabled="this.disabled"
                :type='this.type'
                :newDate="this.newDate"
                @updateParentState="this.setValue"
                :min="this.min"
                :max="this.max"
                :enableSeconds="this.enableSeconds"
                :clearable="this.clearable"
                :autoApply="this.autoApply"
            />
            <div class="d-flex flex-row align-items-center justify-content-end gap-2">
                <!-- <div v-else-if="this.unvisible" class="mw34"></div> -->
                <Popper
                    v-if="this.verification"
                    :hover="true"
                    :id="id + '_check'"
                >
                    <Icon name="check-mark" :color="{ 0: '#018A5A'}" class="c18" />
                    <template #content>
                        <span>{{ $t('views.InfoReg.3') }}</span>
                    </template>
                </Popper>
                <!-- <div v-else-if="this.unvisible || this.vMark" class="mw34"></div> -->
                <Popper v-if="this.unvisible" :hover="true" :id="id + '_av'">
                    <button
                        type="button"
                        class="btn btn-outline-grey eye-toggle"
                        :disabled="this.is_public == '2'"
                        @click="toggleUnvisible"
                    >
                        <Icon :name="unvisibleValue === '1' ? 'eye' : 'eye-off'" size="c20" />
                    </button>
                    <template #content>
                        <span>{{ $t(unvisibleValue === '1' ? 'views.InfoReg.4' : 'views.InfoReg.5') }}</span>
                    </template>
                </Popper>
            </div>
        </div>
    </div>
</template> 

<script>
import InputDateSimple from '@/components/service/InputDateSimple';
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon';
import Popper from '@/components/service/Popper';
export default {
    components: {
        Tooltip,
        InputDateSimple,
        Icon,
        Popper
    },
    data() {
        return {
            value: this.dataValue ? this.dataValue : false,
            unvisibleValue: this.unvisibleDataValue ? this.unvisibleDataValue : '',
        }
    },
    props: {
        id: [String, Boolean],
        label: [String],
        hint: [String],
        dataValue: [String, Boolean],
        verification: [String, Boolean],
        type: {
            default: 'date',
            type: [String, Boolean]
        },
        disabled: [Boolean],
        unvisible: [Boolean],
        unvisibleDataValue: [String, Boolean], 
        vMark: [Boolean],
        expFormat: {
            default: false,
            type: [Boolean]
        },
        is_public: [Boolean, String],
        newDate: {
            default: false,
            type: [Boolean]
        },
        min: {
            default: new Date('1900'),
            type: [Date, Boolean, String]
        },
        max: {
            default: new Date('2100'),
            type: [Date, Boolean, String]
        },
        enableSeconds: {
            default: false,
            type: [Boolean]
        },
        clearable: {
            default: false,
            type: [Boolean]
        },
        autoApply: {
            default: true,
            type: [Boolean]
        },
        ignoreTimeValidation: {
            default: false,
            type: [Boolean]
        },
        labelTop: [Boolean]
    },
    methods: {
        setValue(arg) {
            this.$emit('updateParentState', {
                id: arg.id,
                value: arg.value
            })
        },
        toggleUnvisible() {
            let newValue = this.unvisibleValue === '1' ? '0' : '1';
            this.unvisibleValue = newValue;
            this.$emit('updateParentState', {
                id: this.id,
                unvisible: true,
                value: newValue,
            });
        },
    },
    mounted() {
        console.log('mounted inputDate dataValue', this.dataValue);
    }
}
</script>

<style lang="scss" scoped>
.input {
    font-family: 'HelveticaNeue roman';
    &-wrapper {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
    }
}
.mt-1 {
    margin: 0 !important;
}
.require {
    color: red;
}

</style>